import { Eye, EyeOff } from 'lucide-react';
import { MAINTENANCE_VISIBILITY_LABELS, type MaintenanceVisibility } from '@oficina/shared';
import { cn } from '@/lib/utils';

const OPTIONS: MaintenanceVisibility[] = ['INTERNAL', 'CLIENT_VISIBLE'];

/** Seletor Interno / Visível ao cliente. Interno aparece só no sistema; visível também no PDF e no portal do cliente. */
export function MaintenanceVisibilitySelect({
  value,
  onChange,
  disabled,
  idPrefix,
}: {
  value: MaintenanceVisibility;
  onChange: (value: MaintenanceVisibility) => void;
  disabled?: boolean;
  idPrefix: string;
}) {
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2">
        <span id={`${idPrefix}-visibility-label`} className="text-sm font-medium">
          Visibilidade
        </span>
        <div
          role="radiogroup"
          aria-labelledby={`${idPrefix}-visibility-label`}
          className="inline-flex overflow-hidden rounded-md border"
        >
          {OPTIONS.map((option) => {
            const selected = option === value;
            return (
              <button
                key={option}
                type="button"
                role="radio"
                aria-checked={selected}
                disabled={disabled}
                onClick={() => onChange(option)}
                className={cn(
                  'flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold transition-colors disabled:opacity-60',
                  selected
                    ? option === 'CLIENT_VISIBLE'
                      ? 'bg-emerald-600 text-white'
                      : 'bg-slate-700 text-white'
                    : 'bg-background text-muted-foreground hover:bg-muted',
                )}
              >
                {option === 'CLIENT_VISIBLE' ? <Eye className="h-3.5 w-3.5" aria-hidden /> : <EyeOff className="h-3.5 w-3.5" aria-hidden />}
                {MAINTENANCE_VISIBILITY_LABELS[option]}
              </button>
            );
          })}
        </div>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">
        {value === 'CLIENT_VISIBLE'
          ? 'O cliente verá este registro (e seus anexos) no PDF da OS e no acompanhamento online.'
          : 'Somente a equipe vê este registro. Ele não aparece no PDF nem para o cliente.'}
      </p>
    </div>
  );
}

export function MaintenanceVisibilityBadge({ visibility }: { visibility?: MaintenanceVisibility }) {
  const visible = visibility === 'CLIENT_VISIBLE';
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide',
        visible ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-200 text-slate-700',
      )}
    >
      {visible ? <Eye className="h-3 w-3" aria-hidden /> : <EyeOff className="h-3 w-3" aria-hidden />}
      {MAINTENANCE_VISIBILITY_LABELS[visible ? 'CLIENT_VISIBLE' : 'INTERNAL']}
    </span>
  );
}
